import React from 'react';
import { useForm } from 'react-hook-form';
import { FIELDS, STEPS } from '../utils/constants';
import { useFormStateContext } from '../utils/hooks';
import {
  InputField,
  InputError,
  InputContainer,
  InputLabel,
  Flex,
  Button,
} from '../utils/styles';
import axios from "axios";


const baseURL1 = "http://fantasy.tecpiniondev.com/dosignup";
// const baseURL1 = "/dosignup";

export const PassWord = () => {
  const { fields, setStep, updateFields } = useFormStateContext();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues: { password: fields.password } });

  const goBack = () => {
    setStep(STEPS.COUNTRYCODE);
  };

  const onSubmit = (data) => {
    console.log(data);
    updateFields(FIELDS.PASSWORD, data.password);
    // setStep(STEPS.REVIEW);
    setStep(STEPS.PRIVACYCONSENT);
  };

  const onError = (errors, event) => {
    console.log(errors);
    console.log(event);
  };

  const [post, setPost] = React.useState(null);

  React.useEffect(() => {
    axios.get(`${baseURL1}/1`).then((response) => {
      setPost(response.data);
    });
  }, []);

  function createPost1() {
    console.log(fields)
    var nietos = [];
    var obj = {};
    obj["first_name"] = fields.contact.firstName;
    obj["last_name"] = fields.contact.firstName;
    obj["day"] = fields.birthdate;
    obj["month"] = fields.birthdate;
    obj["year"] = fields.birthdate;
    nietos.push(obj);
    nietos.push(fields.email);
    nietos.push(fields.email);
    nietos.push(fields.password);

   
  }


  return (
    <div className="base-form">
      <form onSubmit={handleSubmit(onSubmit, onError)}>
        <div className='button-back'>
          <Button
            type="button"
            children="Back"
            secondary
            style={{ margin: '0 10px' }}
            onClick={goBack}
          > <i class="fa fa-angle-left" aria-hidden="true"></i></Button>
          <h4>Set logins</h4>      
        </div> 
        <div className="f-container">
          <label className='name'>password</label>
          <InputContainer style={{ margin: '10px 0' }} error={errors.password}>
            <Flex alignItems="center" justifyContent="space-between">
              <InputLabel htmlFor="" children="" />
              {errors.password && <InputError children={errors.password.message} />}
            </Flex>
            <InputField
              id="password"
              type="password"
              minLength={6}
              placeholder='Password'
              {...register('password', {
                required: 'password is required',
                pattern: {
                  message: 'Invalid password number',
                  // value: /^\d{8}$/,
                },
              })}
            />
          </InputContainer>
          {/* <div className='button-next'>
            <Button
              type="button"
              children="Back"
              secondary
              style={{ margin: '0 10px' }}
              onClick={goBack}
            >Back <i class="fa fa-angle-left" aria-hidden="true"></i></Button>
            <Button children="Next" />
          </div> */}
          <div className='button-next'>
          <Button children="Next" onClick={(createPost1)}>Press <span className="enter">Enter</span>  <i class="fa fa-angle-right" aria-hidden="true"></i></Button>
          </div>
          <p class="hidden-xs">&nbsp;</p>
          <div class="terms5">
            <p className='text-center'> Already have an account with us? <a href="/login">Please Sign In</a>
            </p>
          </div>
        </div>
      </form>
    </div>
  );
};
